var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      {
        staticClass: "layout-content",
        class: { "has-foot": _vm.hasTabBar, "no-head": _vm.hasNoHead },
      },
      [
        _c(
          "keep-alive",
          { attrs: { include: _vm.keepAliveArrs } },
          [_c("router-view")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }